import React from 'react';

import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { LetterGradeBadge } from 'components/LetterGradeBadge/LetterGradeBadge';
import { ReactComponent as ArrowRight } from 'style/icons/arrow-right.svg';
const CurrentPotentialPaymentGrade = ({
  currentPaymentTitle = 'current payment history GRADE',
  potentialPaymentTitle = 'potential payment history grade',
  currentPaymentHistoryGrade,
  potentialPaymentHistoryGrade,
}) => {
  return (
    <FlexContainer
      className="column-gap-20 m-column-gap-30 margb30 m-margb0 padlr20"
      justifyCenter
    >
      <FlexContainer className="column-gap-8" column alignItemsCenter>
        <Label type="Overline toUpper text-center margb8 fontGray6">
          {currentPaymentTitle}
        </Label>
        <LetterGradeBadge
          grade={currentPaymentHistoryGrade}
          type="big"
          datatestid="factorGrade"
          changeSizeOnMobile={false}
        />
      </FlexContainer>
      <ArrowRight
        className="width50px align-self-end margb10"
        role="img"
        aria-label="arrowRight"
      />
      <FlexContainer column alignItemsCenter>
        <Label type="Overline toUpper text-center margb8 fontGray6">
          {potentialPaymentTitle}
        </Label>
        <LetterGradeBadge
          grade={potentialPaymentHistoryGrade}
          type="big"
          datatestid="factorGrade"
          changeSizeOnMobile={false}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default CurrentPotentialPaymentGrade;
